import {
    faAngleDown,
    faAnglesUpDown,
    faAngleUp,
    faArrowDownArrowUp,
    faArrowRightFromBracket,
    faArrowTurnDownRight,
    faAsterisk,
    faBarsFilter,
    faBrush,
    faBoxesStacked,
    faCalculator,
    faCartShopping,
    faCartXmark,
    faCheck,
    faChevronDown,
    faChevronUp,
    faCircle,
    faCircleCheck,
    faCircleStar,
    faCircleX,
    faCopy,
    faFile,
    faFileArrowDown,
    faFileArrowUp,
    faFlag,
    faGear,
    faGem,
    faInfo,
    faRuler,
    faRulerCombined,
    faHexagonImage,
    faMicrochipAi,
    faMinus,
    faPalette,
    faPencil,
    faPersonDigging,
    faPersonToDoor,
    faShoppingBasket,
    faChevronRight,
    faTrashCan,
    faTimes,
    faUser,
    faUsers,
    faUserSecret,
    faX,
    faFontCase,
    type IconDefinition,
} from "@fortawesome/pro-light-svg-icons";
import { faEllipsis } from "@fortawesome/pro-light-svg-icons/faEllipsis";
import { faGripDotsVertical } from "@fortawesome/pro-light-svg-icons/faGripDotsVertical";
import { faArrowRight } from "@fortawesome/pro-light-svg-icons/faArrowRight";
import { faTriangleExclamation } from "@fortawesome/pro-light-svg-icons/faTriangleExclamation";

export const lightIcons: IconDefinition[] = [
    faChevronDown,
    faChevronUp,
    faAngleDown,
    faAngleUp,
    faHexagonImage,
    faAnglesUpDown,
    faAsterisk,
    faCartShopping,
    faPencil,
    faArrowRightFromBracket,
    faArrowDownArrowUp,
    faCheck,
    faTrashCan,
    faTimes,
    faCircleStar,
    faUsers,
    faPersonDigging,
    faCopy,
    faPalette,
    faCircleCheck,
    faCircleX,
    faBarsFilter,
    faBrush,
    faCircle,
    faCartXmark,
    faCalculator,
    faUser,
    faShoppingBasket,
    faChevronRight,
    faMicrochipAi,
    faPersonToDoor,
    faX,
    faFile,
    faFileArrowDown,
    faFileArrowUp,
    faEllipsis,
    faUserSecret,
    faBoxesStacked,
    faMinus,
    faArrowTurnDownRight,
    faFlag,
    faGear,
    faGem,
    faInfo,
    faRuler,
    faRulerCombined,
    faGripDotsVertical,
    faArrowRight,
    faTriangleExclamation,
    faFontCase,
];
